import requestService from "./requestService"

const request = requestService

export default {
    async getAll() {
        return await request.get('/customer-hiring/all')
    }
}